import React, { useEffect } from 'react';
import ConfluenceHomeBanner from '@post-office-placement/confluence-home-banner/placement';

import {
	PlacementFetchProvider,
	usePlacementPreloadedData,
} from '@atlassian/confluence-post-office-provider/entry-points/preload-placement';
import { Placement } from '@atlassian/post-office-placement';

import { manuallyLogExpExposure } from '@confluence/feature-experiments';
import { useEmptyFeed } from '@confluence/feed';
import { Attribution, withTransparentErrorBoundary } from '@confluence/error-boundary';

const PLACEMENT_ID = 'confluence-home-banner';

export const HomeBanner = () => {
	const { hasFeed } = useEmptyFeed();
	const preloadedInitialData = usePlacementPreloadedData(PLACEMENT_ID);

	useEffect(() => {
		if (hasFeed) {
			// Only log exposure event if the user is actually seeing the banner
			manuallyLogExpExposure('post_office_confluence_home_banner_experiment_-_v2');
		}
	}, [hasFeed]);

	return hasFeed ? (
		<div role="banner" data-testid="confluence-home-banner-placement">
			<PlacementFetchProvider>
				<Placement
					placementId={PLACEMENT_ID}
					// @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
					PlacementComponent={ConfluenceHomeBanner}
					placementProps={{
						preloadedInitialData,
					}}
				/>
			</PlacementFetchProvider>
		</div>
	) : null;
};

export const PostOfficeHomeBanner = withTransparentErrorBoundary({
	attribution: Attribution.POST_OFFICE,
})(HomeBanner);
